import React, { useState, useMemo } from "react";
import Typical from "react-typical";
import Switch from "react-switch";

const Header = ({ sharedData }) => {
  const [checked, setChecked] = useState(false);

  const onThemeSwitchChange = (checked) => {
    setChecked(checked);
    setTheme();
  };

  const setTheme = () => {
    const dataThemeAttribute = "data-theme";
    const body = document.body;
    const newTheme = body.getAttribute(dataThemeAttribute) === "dark" ? "light" : "dark";
    body.setAttribute(dataThemeAttribute, newTheme);
  };

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight, // Scroll to the next section
      behavior: "smooth",
    });
  };

  let name = "";
  let titles = [];
  if (sharedData) {
    name = sharedData.name;
    titles = sharedData.titles.map((x) => [x.toUpperCase(), 1500]).flat();
  }

  const HeaderTitleTypeAnimation = useMemo(
    () => <Typical className="title-styles" steps={titles} loop={50} />,
    [titles]
  );

  return (
    <header
      id="home"
      style={{
        height: "100vh", // Full viewport height
        display: "block",
        position: "relative", // Allow absolute positioning for the button
      }}
    >
      <div className="row aligner" style={{ height: "100%" }}>
        <div className="col-md-12">
          <div>
            <span
              className="iconify header-icon"
              data-icon="la:laptop-code"
              data-inline="false"
            ></span>
            <h1 className="mb-0">
              <Typical steps={[name]} wrapper="p" />
            </h1>
            <div className="title-container">{HeaderTitleTypeAnimation}</div>
            <Switch
              checked={checked}
              onChange={onThemeSwitchChange}
              offColor="#baaa80"
              onColor="#353535"
              className="react-switch mx-auto"
              width={90}
              height={40}
              uncheckedIcon={
                <span
                  className="iconify"
                  data-icon="twemoji:owl"
                  data-inline="false"
                  style={{
                    display: "block",
                    height: "100%",
                    fontSize: 25,
                    textAlign: "end",
                    marginLeft: "20px",
                    color: "#353239",
                  }}
                ></span>
              }
              checkedIcon={
                <span
                  className="iconify"
                  data-icon="noto-v1:sun-with-face"
                  data-inline="false"
                  style={{
                    display: "block",
                    height: "100%",
                    fontSize: 25,
                    textAlign: "end",
                    marginLeft: "10px",
                    color: "#353239",
                  }}
                ></span>
              }
              id="icon-switch"
            />
          </div>
        </div>
      </div>
      {/* Scroll Down Button */}
      <button
        onClick={scrollToContent}
        style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          background: "none",
          border: "none",
          cursor: "pointer",
          animation: "bounce 2s infinite",
        }}
      >
        <span
          className="iconify"
          data-icon="mdi:chevron-double-down"
          style={{
            fontSize: "36px",
            color: "#ff9800",
            boxShadow: "0 0 15px rgba(255, 152, 0, 0.7)",
          }}
        ></span>
      </button>
      {/* Bounce Animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-10px);
            }
            60% {
              transform: translateY(-5px);
            }
          }
        `}
      </style>
    </header>
  );
};

export default Header;
